import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

export const humanizeDate = (date, format) => (date ? dayjs(date).format(format) : '');
